import { render, staticRenderFns } from "./context-menu.vue?vue&type=template&id=0f58c357"
import script from "./context-menu.vue?vue&type=script&lang=js"
export * from "./context-menu.vue?vue&type=script&lang=js"
import style0 from "./context-menu.vue?vue&type=style&index=0&id=0f58c357&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/graphileon/graphileon/release/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f58c357')) {
      api.createRecord('0f58c357', component.options)
    } else {
      api.reload('0f58c357', component.options)
    }
    module.hot.accept("./context-menu.vue?vue&type=template&id=0f58c357", function () {
      api.rerender('0f58c357', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue-view/context-menu.vue"
export default component.exports